import React from 'react';
import { scrollToOffer } from '../utils/scroll';
import { CONSTANTS } from '../utils/constants';
export const BonusSection: React.FC = () => {
  const bonuses = [{
    num: 1,
    title: 'Mapa Real de Dónde Comprar y Vender Oro en Argentina',
    desc: 'Las zonas, circuitos y estrategias reales para operar. Incluye el circuito callejero, comercial e institucional. Tipos de compradores (fundición, joyero, premium). Señales para detectar un buen lugar vs. uno que te paga mal.',
    includes: '8 módulos · Estrategia de operación · Errores comunes',
    image: CONSTANTS.IMAGES.BONO_1
  }, {
    num: 2,
    title: 'Cómo Vender Oro Usando Instagram y TikTok (Sin Ser Influencer)',
    desc: 'Cómo grabar contenido que vende. Estructura de video probada (hook + valor + cierre). Ejemplos de hooks virales. Cómo armar un perfil de Instagram que genera ventas reales. Sistema simple de contenido diario.',
    includes: '7 módulos · Hooks listos · Estructura de perfil',
    image: CONSTANTS.IMAGES.BONO_2
  }, {
    num: 3,
    title: 'Calculadora de Valor del Oro (USD + Dólar Blue)',
    desc: 'Planilla Excel lista para usar. Ingresás gramos, quilates y cotización del día → te calcula el valor en USD, en pesos al blue y tu precio de compra sugerido al 70-80% automáticamente.',
    includes: 'Planilla Excel · Cálculo automático · Lista para usar',
    image: CONSTANTS.IMAGES.BONO_3
  }];
  return <section className="py-20" style={{
    background: 'var(--bg-card)'
  }} data-id="element-31">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-2" data-id="element-34">
            Solo por hoy:{' '}
            <span style={{
            color: 'var(--gold)'
          }} data-id="element-35">
              3 bonos incluidos GRATIS
            </span>
          </h2>
          <p style={{
          color: 'var(--text-secondary)'
        }} data-id="element-36">
            Recursos adicionales para que tu primera operación salga bien desde
            el día 1.
          </p>
        </div>

        <div className="space-y-5" data-id="element-37">
          {bonuses.map((bonus, idx) => <div key={idx} onClick={scrollToOffer} className="rounded-xl p-6 sm:p-8 border flex flex-col sm:flex-row gap-6 items-center cursor-pointer transition-all duration-300 hover:border-gold" style={{
          background: 'var(--bg-dark)',
          borderColor: 'var(--border-subtle)'
        }} data-id="element-38">
              <div className="flex-shrink-0 w-32 sm:w-36" data-id="element-39">
                <img src={bonus.image} alt={`Bono ${bonus.num} – ${bonus.title}`} className="w-full h-auto rounded-lg drop-shadow-lg" data-id="element-40" />
              </div>
              <div className="flex-grow" data-id="element-41">
                <div className="mb-3" data-id="element-42">
                  <span className="px-3.5 py-1.5 rounded text-xs font-extrabold tracking-widest uppercase inline-block" style={{
                background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
                color: 'var(--bg-dark)'
              }} data-id="element-43">
                    GRATIS
                  </span>
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-44">
                  BONO {bonus.num} – {bonus.title}
                </h3>
                <p className="text-sm mb-2 leading-relaxed" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-45">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium" style={{
              color: 'var(--gold)'
            }} data-id="element-46">
                  Incluye: {bonus.includes}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-47">
          <button onClick={scrollToOffer} className="font-bold text-lg px-10 py-4 rounded-md uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 w-full sm:w-auto" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
          color: 'var(--bg-dark)',
          boxShadow: '0 4px 20px rgba(200,163,78,0.3)'
        }} data-id="element-48">
            ACCEDER A TODO + LOS 3 BONOS
          </button>
        </div>
      </div>
    </section>;
};